<template>
    <div class="app-container"></div>
</template>

<script>
    export default {
        components: {},
        data() {
            return {};
        },
        methods: {},
    };
</script>

<style lang="scss" scoped>
    .app-container {
    }
</style>